import * as types from '../actions/types';

const INITIAL_STATE = 'none';

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_MODAL:
      return action.payload;
    default:
      return state;
  }
};
